<template>
    <!-- Connections List Page -->
    <div class="page-layout blank contacts-manage">
        <div class="d-flex align-items-center justify-content-center h-100" v-if="callInProgress">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
        </div>
        <div class="pb-10 pr-2" v-else>
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbnew mr-5">
                    <span>Contacts</span>
                    <a>Connections</a>
                </div>
                <div class="d-flex" style="flex-grow: 1">
                    <i class="icon icon-magnify icondefault" style="border-radius: 20px 0px 0px 20px; padding: 8px 16px; height: 2.7em;"></i>
                    <input class="w-100" type="text" v-model="search_key" placeholder="Search by Name or Email ID" style="border-radius: 0px 20px 20px 0px; padding-left: 10px; height: 2.9em;">
                </div>
            </div>
            <div class="header-outer">
                <span class="fw-500">Connections</span>
                <span class="pointer" @click="showConnections">
                    <i v-if="connectionsTab" class="icon-chevron-double-up text-white" style="font-size: 20px"></i>
                    <i v-else class="icon-chevron-double-down text-white" style="font-size: 20px"></i>
                </span>
            </div>
            <div v-if="searchInProgress">
                <div class="d-flex align-items-center justify-content-center h-100" v-if="searchInProgress">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                </div>
            </div>
            <div v-else>
                <div class="inner-div pt-7" v-if="connectionsTab && connections.length">
                    <div class="d-flex flex-wrap pt-4 px-4 pb-0" style="background: #e8efff; border-radius: 5px">
                        <div class="tabs d-flex align-items-center mr-4 mb-4" v-for="(connection,index) in connections" :key="index">
                            <img class="ml-4" :src="connection.profile_pic" style="width: 3.5em; height: 3.5em; border-radius: 50%">
                            <div class="d-flex flex-column ml-2">
                                <span class="fs-14" style="color: #414141">{{ connection.full_name }}</span>
                                <span class="fs-12" style="color: #949494">{{ connection.email || "-" }}</span>
                            </div>
                            <el-dropdown trigger="click" style="width: auto !important; position: absolute; margin-left: 18.5em; margin-bottom: 3em;">
                                <i class="icon icon-dots-vertical" style="color: #949494;"></i>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="$router.push('/userprofile/' + connection.user_id)">View Profile</el-dropdown-item>
                                    <el-dropdown-item style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;" @click.native="removeConnection(connection._id)">Remove Connection</el-dropdown-item>
                                    <!-- <el-dropdown-item style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;">Unfollow</el-dropdown-item>
                                    <el-dropdown-item style="color: #4a4a4a !important; padding: 0px 10px; font-size: 12px; font-weight: 500;">Block</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
                <div class="inner-div pt-6" v-if="!connections.length">
                    <div class="d-flex justify-content-center align-items-center py-4" style="background: #e8efff; border-radius: 5px">
                        <span class="fw-600 fs-18">No Connections Found</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
export default {
    data() {
        return {
            limit: 10,
            count: 0,
            search_key: "",
            connectionsTab: true,
            connections: [],
            callInProgress: false,
            searchInProgress: false
        }
    },
    components: {
        HalfCircleSpinner
    },
    methods: {
        showConnections() {
            if (this.connectionsTab) {
                this.connectionsTab = false;
            } else {
                this.connectionsTab = true;
            }
        },
        async getConnectionsList() {
            this.searchInProgress = true;
            let params = {
                limit: this.limit,
                skip: this.count * this.limit,
                search_key: this.search_key,
            };
            let res = await this.$http.post("/connections/list_view", params);
            if (res.data.status_id == 1) {
                this.connections = res.data.response;
                this.searchInProgress = false;
            }
        },
        async removeConnection(id) {
            let res = await this.$http.get("/connections/remove_connection?id=" + id);
            if (res.data.status_id == 1) {
                this.getConnectionsList();
            }
        }
    },
    created() {
        this.getConnectionsList();
    },
    watch: {
        search_key: function() {
            this.getConnectionsList();
        }
    }
}
</script>

<style scoped>
    .header-outer {
        width: 100%;
        background: #005dae;
        color: #fff;
        font-size: 14px;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-right: 20px;
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    .inner-div {
        padding-bottom: 30px;
        padding-left: 30px;
        padding-right: 30px;
        background: #fff;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .tabs {
        background: #fff;
        border-radius: 5px;
        width: 22em;
        height: 6em;
    }
</style>


// WEBPACK FOOTER //
// src/components/ConnectionLIst.vue